import React from "react";
import { Box, Tooltip } from "@material-ui/core";
import { get } from "lodash";
import DefaultTargetImg from "Assets/images/target-default-image.svg";
import { useStyles } from "../styles";

const TargetTitle = ({
  colProps,
  teamTarget = false,
  onRowClick,
  otherInfo,
}) => {
  const classes = useStyles();

  return teamTarget ? (
    <td style={colProps.style} className={`${colProps.className}`}>
      <Tooltip placement="bottom-start" title={get(colProps, "dataItem.title")}>
        <span className={`${classes.targetTitle} multi-wrap-2`}>
          {get(colProps, "dataItem.title")}
        </span>
      </Tooltip>
      {otherInfo ? otherInfo : ""}
    </td>
  ) : (
    <td
      style={colProps.style}
      className={`${colProps.className}`}
      onClick={() => onRowClick && onRowClick(colProps)}
    >
      <Tooltip placement="bottom-start" title={get(colProps, "dataItem.title")}>
        <Box
          className={`${onRowClick ? "cursor-pointer" : ""} target-title`}
          display="flex"
          data-testid="onRowClick"
          alignItems="center"
        >
          <img
            src={
              get(colProps, "dataItem.targetImage", "")
                ? get(colProps, "dataItem.targetImage", "")
                : get(colProps, "dataItem.logo.fileName", "")
                ? `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
                    colProps,
                    "dataItem.logo.fileName",
                    ""
                  )}`
                : DefaultTargetImg
            }
            alt="checkinimage"
            className={`${
              get(colProps, "dataItem.targetImage", "")
                ? classes.targetImage
                : classes.targetImgDefault
            } target-img`}
            
          />
          <span className="multi-wrap-2" tabIndex={0}>
            {get(colProps, "dataItem.title")}
          </span>
        </Box>
      </Tooltip>
      {otherInfo ? otherInfo : ""}
    </td>
  );
};

export default TargetTitle;
